import React from 'react'
import styled from '@emotion/styled'
import { BreakPoint } from 'src/components/shared/CssValues'
import pointImg from 'src/images/whitepapers/a-check.jpg'
import { Typography } from 'src/components/atoms/Typography'

type Props = {
  intro?: string
  thumbnail: string
  feature1: string
  feature2: string
  feature3: string
  description: string
}

const PaperIntroduction = ({
  intro,
  thumbnail,
  feature1,
  feature2,
  feature3,
  description
}: Props) => {
  const pageIntro = intro ?? '本資料を読むと下記のようなことがわかります。'
  return (
    <Container>
      <LeftContent>
        <Thumbnail src={thumbnail} />
      </LeftContent>

      <RightContent>
        <Text as="p">{pageIntro}</Text>

        <PointList>
          <PointListItem>
            <PointImage src={pointImg} />
            <PointText as="p">{feature1}</PointText>
          </PointListItem>
          {feature2 &&
            <PointListItem>
              <PointImage src={pointImg} />
              <PointText as="p">{feature2}</PointText>
            </PointListItem>
          }
          {feature3 &&
            <PointListItem>
              <PointImage src={pointImg} />
              <PointText as="p">{feature3}</PointText>
            </PointListItem>
          }
        </PointList>

        <Description as="p">{description}</Description>
      </RightContent>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 50px;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin-top: 40px;
    display: block;
  }
`

const LeftContent = styled.div`
  width: 47.474%;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
  }
`

const Thumbnail = styled.img`
  width: 100%;
`

const RightContent = styled.div`
  width: 50.505%;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
  }
`

const PointList = styled.div``

const PointListItem = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`

const PointImage = styled.img`
  width: 24px;
  height: 24px;
`

const PointText = styled(Typography)`
  margin-left: 20px;
  font-size: 17px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: 1.2px;
  color: #333333;
`

const Text = styled(Typography)`
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: 1.2px;
  color: #333333;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin-top: 20px;
  }
`

const Description = styled(Typography)`
  white-space: pre-wrap;
  margin-top: 20px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: 1.2px;
  color: #333333;
`

export default PaperIntroduction
